













import { Vue, Component, Prop, VModel, Watch } from 'vue-property-decorator'

import { MiniPopupPosition } from './types'

@Component({
  data: () => ({
    MiniPopupPosition,
  }),
})
export default class MiniPopup extends Vue {
  @VModel({ type: Boolean, default: false }) isPopupOpen!: boolean

  @Prop({ type: Boolean, default: false }) readonly outsideClickClose!: boolean

  @Prop({ type: Function }) readonly countPopupPositionFn!: ((el: HTMLElement) => string) | undefined

  @Prop({ type: Number, default: MiniPopupPosition.Center }) readonly position!: MiniPopupPosition

  @Watch('isPopupOpen')
  onPopupOpenStateToggle(value: boolean): void {
    if (value) {
      this.$nextTick(() => {
        this.countPopupPositionHandler()
      })
    }
  }

  countPopupPositionHandler(): void {
    const miniPopupEl: HTMLElement = this.$el as HTMLElement
    if (this.countPopupPositionFn) {
      miniPopupEl.style.cssText = this.countPopupPositionFn(miniPopupEl)
    }
  }

  mounted(): void {
    this.onPopupOpenStateToggle(this.isPopupOpen)

    if (this.outsideClickClose) {
      window.addEventListener('click', (e) => {
        const miniPopupEl: HTMLElement = this.$el as HTMLElement
        const targetEl = e.target as Node | null
        if (
          targetEl !== miniPopupEl
          && !miniPopupEl.contains(targetEl)
          && miniPopupEl.parentNode
          && !miniPopupEl.parentNode.contains(targetEl)
        ) {
          this.isPopupOpen = false
        }
      })
    }
  }
}
